export default "__VITE_PUBLIC_ASSET__7fc08ed1__"